"use strict";

var _reactTransformCatchErrors2 = require("react-transform-catch-errors");

var _interopRequireDefault = require("babel-runtime/helpers/interop-require-default")["default"];

var _reactTransformCatchErrors3 = _interopRequireDefault(_reactTransformCatchErrors2);

var _react = require("react");

var _redboxReact = require("redbox-react");

var _inherits = require("babel-runtime/helpers/inherits")["default"];

var _classCallCheck = require("babel-runtime/helpers/class-call-check")["default"];

exports.__esModule = true;

var _react2 = _interopRequireDefault(_react);

var _components = {
  _$AppFooter: {
    displayName: "AppFooter"
  }
};

var _reactComponentWrapper = _reactTransformCatchErrors3["default"]({
  filename: "/var/www/websites/blog.paymentwall.com/releases/20220825105928/src/components/AppFooter/AppFooter.js",
  components: _components,
  locals: [],
  imports: [_react, _redboxReact]
});

var _reactComponentWrapper2 = _reactTransformCatchErrors3["default"]({
  filename: "/var/www/websites/blog.paymentwall.com/releases/20220825105928/src/components/AppFooter/AppFooter.js",
  components: _components,
  locals: [],
  imports: [_react, _redboxReact]
});

function _wrapComponent(uniqueId) {
  return function (ReactClass) {
    return _reactComponentWrapper2(_reactComponentWrapper(ReactClass, uniqueId), uniqueId);
  };
}

var AppFooter = (function (_Component) {
  _inherits(AppFooter, _Component);

  function AppFooter() {
    _classCallCheck(this, _AppFooter);

    _Component.apply(this, arguments);
  }

  AppFooter.prototype.render = function render() {
    return _react2["default"].createElement(
      "footer",
      { className: "page-footer" },
      _react2["default"].createElement(
        "div",
        { className: "container" },
        _react2["default"].createElement(
          "div",
          { className: "page-footer__content" },
          _react2["default"].createElement(
            "div",
            { className: "page-footer__logo" },
            _react2["default"].createElement(
              "svg",
              { className: "page-footer__logo-icon" },
              _react2["default"].createElement("use", { xlinkHref: "#pw-icon" })
            ),
            _react2["default"].createElement(
              "a",
              { className: "page-footer__logo-link", href: "https://www.paymentwall.com/" },
              "Paymentwall.com"
            )
          ),
          _react2["default"].createElement(
            "div",
            { className: "page-footer__social" },
            _react2["default"].createElement(
              "a",
              { className: "page-footer__social-link", href: "https://www.facebook.com/paymentwall" },
              _react2["default"].createElement(
                "svg",
                { className: "icon icon--facebook", viewBox: "0 0 11 22" },
                _react2["default"].createElement("use", { xlinkHref: "#icon-facebook" })
              )
            ),
            _react2["default"].createElement(
              "a",
              { className: "page-footer__social-link", href: "https://plus.google.com/115554590552671528350/videos" },
              _react2["default"].createElement(
                "svg",
                { className: "icon icon--googleplus", viewBox: "0 0 30 21" },
                _react2["default"].createElement("use", { xlinkHref: "#icon-googleplus" })
              )
            ),
            _react2["default"].createElement(
              "a",
              { className: "page-footer__social-link", href: "https://www.linkedin.com/company/paymentwall-inc." },
              _react2["default"].createElement(
                "svg",
                { className: "icon icon--linkedin", viewBox: "0 0 22 22" },
                _react2["default"].createElement("use", { xlinkHref: "#icon-linkedin" })
              )
            ),
            _react2["default"].createElement(
              "a",
              { className: "page-footer__social-link", href: "https://twitter.com/paymentwall" },
              _react2["default"].createElement(
                "svg",
                { className: "icon icon--twitter", viewBox: "0 0 23 19" },
                _react2["default"].createElement("use", { xlinkHref: "#icon-twitter" })
              )
            )
          ),
          _react2["default"].createElement(
            "div",
            { className: "page-footer__cta" },
            _react2["default"].createElement(
              "span",
              { className: "page-footer__cta-caption" },
              "Ready to expand your business?"
            ),
            _react2["default"].createElement(
              "a",
              { className: "page-footer__cta-btn btn btn--primary", href: "https://www.paymentwall.com/consultation?source=blog" },
              _react2["default"].createElement(
                "span",
                { className: "btn__text" },
                "Contact us"
              )
            )
          )
        )
      )
    );
  };

  var _AppFooter = AppFooter;
  AppFooter = _wrapComponent("_$AppFooter")(AppFooter) || AppFooter;
  return AppFooter;
})(_react.Component);

exports["default"] = AppFooter;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./src/components/AppFooter/AppFooter.js
// module id = 663
// module chunks = 0